export function min(values: number[]): number | undefined {
  let min: number | undefined;
  for (const value of values) {
    if (min === undefined || min > value) {
      min = value;
    }
  }
  return min;
}

export function max(values: number[]): number | undefined {
  let max: number | undefined;
  for (const value of values) {
    if (max === undefined || max < value) {
      max = value;
    }
  }
  return max;
}

export function clamp(value: number, opts?: {min?: number; max?: number}): number {
  const {min = 0, max = 1} = opts ?? {};
  return Math.min(Math.max(value, min), max);
}
